
const currentBuildVersion = () => {
    // return authorization header with basic auth credentials
    let appDetails = JSON.parse(localStorage.getItem('appDetails'));

    if (appDetails && appDetails.buildVersion) {
        return appDetails.buildVersion;
    } else {
        return "-";
    }
};

export default {
    currentBuildVersion
};